import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Tooltip } from '@material-ui/core';
import { downloadFileFromS3, getLinkDownloadFileFromS3 } from '../common/FileUploaded';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { I18n } from 'aws-amplify';
import { PropTypes } from 'prop-types';
import { displayTagOfThumbAttach } from '../ticketKnowledge/handler/ListTicketKnowledgeHandler';

export default function DetailTicketListThumbnail(props) {
    const {
        ticket,
        openTicketDetailPanel,
        setOpenPreviewImage,
        setOpenOption,
        setOpenFileOption
    } = props;

    return (
        <div className="ticket-thumbnail-frame">
            <div className="ticketThumb">
                <ul>
                    {[
                        ...(!ticket?.isHideAttachment
                            ? ticket.attachment?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                            : []
                        ),
                        ...ticket.attachFiles
                            .filter(
                                i =>
                                    i?.originId?.includes(Constant.ID_PREFIX.CHAT_POST)
                            )
                            ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                    ]
                        ?.slice(0, Constant.ATTACH_FILES_LIMIT)
                        .map((file, index) => {
                            if (
                                ticket.attachFiles
                                    .filter(i => i?.originId?.includes(Constant.ID_PREFIX.CHAT_POST))
                                    .includes(file)
                            ) {
                                file.fileName = file.fileInfo.fileName;
                                file.fileUrl = file.fileInfo.fileUrl;
                                file.fileSize = file.fileInfo.fileSize;
                            }

                            const displayTextInFile = displayTagOfThumbAttach(
                                ticket,
                                file.fileName
                            );

                            const thumbnailInfo =
                                file?.thumbnailInfo ||
                                ticket.attachFiles?.find(
                                    att => att?.fileInfo?.fileUrl === file.fileUrl
                                )?.thumbnailInfo;

                            const imgThumbnailLink = getLinkDownloadFileFromS3(
                                {
                                    ...file,
                                    type: Constant.S3_FILE_TYPE.TICKET_FILE,
                                    thumbnailInfo: JSON.stringify(thumbnailInfo)
                                },
                                ticket,
                                null,
                                Constant.ATTACH_FILE.VIEW_TICKET
                            );

                            const imgLink = getLinkDownloadFileFromS3(
                                {
                                    ...file,
                                    type: Constant.S3_FILE_TYPE.TICKET_FILE,
                                    thumbnailInfo: null
                                },
                                ticket
                            );

                            return (
                                <>
                                    <Tooltip
                                        title={file.fileName}
                                        aria-label={file.fileName}
                                        key={index}
                                    >
                                        <li style={{ display: 'flex', position: 'relative' }}>
                                            <span
                                                style={{
                                                    backgroundColor: displayTextInFile.colorCode,
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    color: 'white',
                                                    borderBottomRightRadius: 5,
                                                    fontSize: 11,
                                                    textAlign: 'center',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    maxWidth: 50,
                                                    minHeight: 14,
                                                    minWidth: 29
                                                }}
                                            >
                                                {displayTextInFile.name}
                                            </span>
                                            <img
                                                src={
                                                    Utils.isImageFile(file.fileName)
                                                        ? imgThumbnailLink
                                                        : '/assets/image/others_file.png'
                                                }
                                                alt=""
                                                aria-label="more"
                                                aria-controls="long-menu"
                                                aria-haspopup="true"
                                                onClick={() => {
                                                    if (Utils.isImageFile(file.fileName)) {
                                                        setOpenPreviewImage(imgLink);
                                                    } else {
                                                        downloadFileFromS3(
                                                            {
                                                                content: file.fileName,
                                                                fileSize: parseInt(file.fileSize),
                                                                fileUrl: file.fileUrl,
                                                                type: 1
                                                            },
                                                            ticket,
                                                            false,
                                                            false,
                                                            '',
                                                            props?.setIsShowPopupLogout
                                                        );
                                                    }
                                                }}
                                                style={{ objectFit: 'cover' }}
                                            />
                                            {ticket && ticket.public !== Constant.TICKET_PUBLIC.DRAFT && Utils.isImageFile(file.fileName) && (
                                                <div
                                                    style={{
                                                        height: '100%',
                                                        backgroundColor: 'transparent',
                                                        width: 16,
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        flexShrink: 0
                                                    }}
                                                    onClick={e => {
                                                        setOpenFileOption(
                                                            ticket.attachFiles.find(
                                                                i =>
                                                                    i.fileInfo.fileUrl ===
                                                                    file?.fileUrl
                                                            )
                                                        );
                                                        setOpenOption(e.currentTarget);
                                                    }}
                                                >
                                                    <img
                                                        src="/assets/image/icon-more-panel.svg"
                                                        alt=""
                                                    />
                                                </div>
                                            )}
                                        </li>
                                    </Tooltip>
                                </>
                            );
                        })}
                    {(!ticket?.isHideAttachment ? ticket?.attachment?.length : 0) +
                        ticket?.attachFiles?.filter(
                            i =>
                                i?.originId?.includes('post') &&
                                Utils.isImageFile(i?.fileInfo?.fileName)
                        )?.length >
                        Constant.ATTACH_FILES_LIMIT && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div
                                style={{
                                    display: 'flex',
                                    padding: '2px 5px',
                                    border: '1px solid #2D72D2',
                                    borderRadius: 8,
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    marginTop: 5
                                }}
                                onClick={openTicketDetailPanel}
                            >
                                <p
                                    style={{
                                        color: '#2D72D2',
                                        fontSize: 12,
                                        fontWeight: 600,
                                        fontFamily: 'Zen Kaku Gothic New'
                                    }}
                                >
                                    {I18n.get('COMBTN009')}
                                </p>
                                <ChevronRightIcon style={{ color: '#2D72D2' }} />
                            </div>
                        </div>
                    )}
                </ul>
            </div>
        </div>
    );
}

DetailTicketListThumbnail.propTypes = {
    ticket: PropTypes.any,
    openTicketDetailPanel: PropTypes.any,
    setOpenPreviewImage: PropTypes.any,
    setOpenOption: PropTypes.any,
    setOpenFileOption: PropTypes.any,
    setIsShowPopupLogout: PropTypes.any
};
